// copy-paste of @ovpn-ui-toolkit/mf-common package utils

setAuthToken.TRIGGER = '@auth/SET_AUTH_TOKEN/TRIGGER';
export function setAuthToken() {
    return {
        type: setAuthToken.TRIGGER,
    };
}

unauthorized.TRIGGER = '@auth/UNAUTHORIZED/TRIGGER';
export function unauthorized() {
    return {
        type: unauthorized.TRIGGER,
    };
}

export function getTenant(): string {
    const tenant = window.location.hostname.split('.')[0];

    if (tenant === 'opsportal') {
        return window.location.pathname.split('/')[2];
    }

    return tenant;
}
